module.exports = __webpack_public_path__ + "img/mentoring.03a32941.svg";